import React from 'react'

import Footer from "../components/Footer";
import Header from "../components/Header";
import CreateVoucher from "../components/CreateVoucher";
import ViewVouchers from '../components/ViewVouchers';
import NavBar from '../components/NavBar';


const Home = () => {
    return (
        <div>
            <Header />
            <NavBar />
            <CreateVoucher />
            
            <ViewVouchers limit={6}/>
            
            <Footer />
        </div>
    )
}

export default Home
